<template lang="pug">
    .animation(ref='animation')
        .cleaver(ref='cleaver')
            img(src='../../assets/img/animations/cleaver.svg')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('top-bottom', 'bottom-top');
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline.fromTo(
                this.$refs.cleaver,
                {rotate: 0},
                {
                    duration: 2,
                    repeat: 2,
                    keyframes: [
                        {rotate: 25, ease: 'power1.out', transformOrigin: '100% 100%'},
                        {rotate: -25, ease: 'power1.in', transformOrigin: '90% 90%'}
                    ]
                },
                0
            );
            this.timeline.progress(0.0001);
            this.timeline.pause();
        }
    }
};
</script>
<style lang="scss" scoped>
.animation {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 40px;
    @media (--viewport-tablet) {
        padding-top: 70px;
    }
}
</style>
